<script lang="ts">

    export let size = 27;
    export let color = '#fff';

</script>

<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 27 27">
    <path fill={color} d="M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12ZM7.5,22.5h-3v6a3.009,3.009,0,0,0,3,3h6v-3h-6Zm0-15h6v-3h-6a3.009,3.009,0,0,0-3,3v6h3Zm21-3h-6v3h6v6h3v-6A3.009,3.009,0,0,0,28.5,4.5Zm0,24h-6v3h6a3.009,3.009,0,0,0,3-3v-6h-3Z" transform="translate(-4.5 -4.5)" />
</svg>
